import './font/style.css';
import './index.less';
import './home.less';
import './price.less';
import './collect.less';
import './order.less';
import './setting.less';
import './init.less';
import './dev.less';
import './oc.less';
import './sys.less';


// WEBPACK FOOTER //
// ./src/style/index.js